import TextInput from 'components/Inputs/TextInput/TextInputV2';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Header, StyledButton, StyledForm, StyledGumbLogo } from '../styled';
import { FIELDS } from './form';
import { useResetPassword } from './hooks';

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { register, onSubmit, errors } = useResetPassword(location);

  return (
    <StyledForm onSubmit={onSubmit}>
      <StyledGumbLogo />
      <Header>{t('auth.recovery')}</Header>
      <TextInput
        register={register}
        error={errors[FIELDS.PASSWORD]}
        type="password"
        name={FIELDS.PASSWORD}
        label={t('auth.labels.password')}
        withShowIcon
      />
      <TextInput
        register={register}
        error={errors[FIELDS.CONFIRM_PASSWORD]}
        type="password"
        name={FIELDS.CONFIRM_PASSWORD}
        label={t('auth.labels.confirmPassword')}
      />
      <StyledButton>{t('auth.reset')}</StyledButton>
    </StyledForm>
  );
};

export default ResetPasswordPage;
